import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('DISCOUNT_FACTOR', ['FORM', 'TABLE_PRODUCTS'])
